import { createAsyncThunk } from '@reduxjs/toolkit';
import { ISearchDataRetentionLog } from '../../../services/master/dataRetentionLog/dataRetentionLog.model';
import dataRetentionLogService from '../../../services/master/dataRetentionLog/dataRetentionLog.service';

export const searchDataRetentionLog = createAsyncThunk(
  'searchDataRetentionLog',
  async (searchParam?: ISearchDataRetentionLog) => {
    const response = await dataRetentionLogService
      .searchDataRetentionLog(searchParam)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);
